import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteCustomField } from '../../../apiclients/streamsapi_bridge';

function DeleteCustomField({ fieldId,onClose }) {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();

    async function removeThisField(e) {
        try {
            setInternalError(false);
            setIsloading(true);
            let deleteGrpReponse = await deleteCustomField(JSON.parse(sessionStorage.getItem("admin_session")).siteid,fieldId);
            setTimeout(() => { setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                onClose();

                navigate("/contactslanding", {
                    state: { tab: "tab3" },
                });
                window.location.reload();

            } else {
                localStorage.setItem("f_message", delInfo.message);
                navigate("/contactslanding", {
                    state: { tab: "tab3" },
                });
                window.location.reload();
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveCustomFieldtxt")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisField(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    );
}

export default DeleteCustomField
